import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AuthPopupCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash && hash.includes('session_id=')) {
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (sessionId && window.opener) {
        // Send session_id back to the parent window
        window.opener.postMessage(
          { type: 'eventdrop_auth', session_id: sessionId },
          '*'
        );
        window.close();
        return;
      }
    }
    // If no opener (direct navigation), handle normally
    if (!window.opener) {
      window.location.href = `/dashboard${location.hash}`;
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#15161B] flex items-center justify-center">
      <div className="text-center text-white">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-[#B89762]/40 border-t-transparent mx-auto mb-4"></div>
        <p className="text-sm text-gray-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthPopupCallback;
